import { countries } from "countries-list";

class CountriesDropdown {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.countries().forEach(country => {
            let option = document.createElement('option');
            option.setAttribute('value', country);
            option.textContent = country;
            self.elem.appendChild(option);
        });
    }

    countries() {
        const countryCodes = Object.keys(countries.countries);
        const countryNames = countryCodes.map(code => countries.countries[code].name);
        
        return countryNames.sort();
    }
}

export default CountriesDropdown;